export default "__VITE_ASSET__Boa6L8_n__"